module.exports = __webpack_public_path__ + "img/mobile-assets.d10fe4a1.svg";